(function () {
    const API_BASE = 'https://chayas-reviews-staging.copetence.de';

    function renderStars(rating) {
        const r = Math.max(0, Math.min(5, Math.round(Number(rating) || 0)));
        return '★'.repeat(r) + '☆'.repeat(5 - r);
    }

    function formatDate(iso) {
        if (!iso) return '';
        const d = new Date(iso);
        if (isNaN(d)) return '';
        return d.toLocaleDateString('de-DE', { year: 'numeric', month: 'long', day: 'numeric' });
    }

    let lightboxEl = null;
    let lastFocused = null;

    function getLightbox() {
        if (lightboxEl) return lightboxEl;

        lightboxEl = document.createElement('div');
        lightboxEl.className = 'reviews-lightbox';
        lightboxEl.hidden = true;
        lightboxEl.innerHTML =
            '<button type="button" class="reviews-lightbox__close" aria-label="Schließen">&times;</button>' +
            '<img class="reviews-lightbox__img" alt="">';

        lightboxEl.addEventListener('click', (e) => {
            if (e.target === lightboxEl || e.target.closest('.reviews-lightbox__close')) closeLightbox();
        });

        document.body.append(lightboxEl);
        return lightboxEl;
    }

    function closeLightbox() {
        if (!lightboxEl || lightboxEl.hidden) return;
        lightboxEl.hidden = true;
        document.body.style.removeProperty('overflow');
        document.removeEventListener('keydown', onLightboxKeydown);
        lastFocused?.focus?.();
        lastFocused = null;
    }

    function onLightboxKeydown(e) {
        if (e.key === 'Escape') closeLightbox();
    }

    function openLightbox(src) {
        const el = getLightbox();
        lastFocused = document.activeElement;
        el.querySelector('.reviews-lightbox__img').src = src;
        el.hidden = false;
        document.body.style.overflow = 'hidden';
        document.addEventListener('keydown', onLightboxKeydown);
        el.querySelector('.reviews-lightbox__close').focus();
    }

    function renderCard(tpl, review) {
        const card = tpl.content.firstElementChild.cloneNode(true);

        const starsEl = card.querySelector('.review-card__stars');
        starsEl.textContent = renderStars(review.rating);
        starsEl.setAttribute('aria-label', `${review.rating} von 5 Sternen`);

        const titleEl = card.querySelector('.review-card__title');
        if (review.title) titleEl.textContent = review.title;
        else titleEl.remove();

        card.querySelector('.review-card__body').textContent = review.body || '';
        card.querySelector('.review-card__author-name').textContent = review.authorName || '';

        const dateEl = card.querySelector('.review-card__date');
        if (review.createdAt) {
            dateEl.textContent = formatDate(review.createdAt);
            dateEl.setAttribute('datetime', review.createdAt);
        } else {
            dateEl.remove();
        }

        const attachmentsEl = card.querySelector('.review-card__attachments');
        const imgs = (review.attachments || []).filter(a => (a.contentType || '').startsWith('image/'));
        if (imgs.length) {
            for (const a of imgs) {
                const btn = document.createElement('button');
                btn.type = 'button';
                btn.className = 'review-card__attachment';
                btn.setAttribute('aria-label', 'Bild vergrößern');

                const img = document.createElement('img');
                img.src = a.url;
                img.alt = '';
                img.loading = 'lazy';

                btn.append(img);
                btn.addEventListener('click', () => openLightbox(a.url));
                attachmentsEl.append(btn);
            }
        } else {
            attachmentsEl.remove();
        }

        return card;
    }

    function renderSummary(sectionEl, reviews) {
        const summaryEl = sectionEl.querySelector('[data-reviews-summary]');
        if (!summaryEl) return;
        if (!Array.isArray(reviews) || reviews.length === 0) {
            summaryEl.classList.add('hidden');
            return;
        }

        const avg = reviews.reduce((sum, r) => sum + (Number(r.rating) || 0), 0) / reviews.length;
        const count = reviews.length;

        const starsEl = summaryEl.querySelector('[data-reviews-summary-stars]');
        const scoreEl = summaryEl.querySelector('[data-reviews-summary-score]');
        const countEl = summaryEl.querySelector('[data-reviews-summary-count]');

        if (starsEl) starsEl.textContent = renderStars(avg);
        if (scoreEl) scoreEl.textContent = `${avg.toFixed(1).replace('.', ',')} von 5`;
        if (countEl) countEl.textContent = `(${count} ${count === 1 ? 'Bewertung' : 'Bewertungen'})`;

        summaryEl.setAttribute(
            'aria-label',
            `Durchschnittliche Bewertung ${avg.toFixed(1).replace('.', ',')} von 5 Sternen bei ${count} ${count === 1 ? 'Bewertung' : 'Bewertungen'}`
        );
        summaryEl.classList.remove('hidden');
    }

    async function loadSection(sectionEl) {
        const groupId = sectionEl.dataset.productGroup;
        const grid = sectionEl.querySelector('[data-reviews-container]');
        const tpl = sectionEl.querySelector('[data-reviews-template]');
        const loadingEl = sectionEl.querySelector('[data-reviews-loading]');
        const emptyEl = sectionEl.querySelector('[data-reviews-empty]');
        const errorEl = sectionEl.querySelector('[data-reviews-error]');

        if (!groupId) {
            console.warn('reviews: missing data-product-group (product.metafields.custom.product_group)', sectionEl);
            loadingEl?.classList.add('hidden');
            return;
        }
        if (!API_BASE) {
            console.warn('reviews: API_BASE not set in reviews.js');
            loadingEl?.classList.add('hidden');
            errorEl?.classList.remove('hidden');
            return;
        }

        let reviews;
        try {
            const url = `${API_BASE}/product-groups/${encodeURIComponent(groupId)}/reviews`;
            const res = await fetch(url, { headers: { Accept: 'application/json' } });
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            reviews = await res.json();
        } catch (err) {
            console.error('reviews: load failed', err);
            loadingEl?.classList.add('hidden');
            errorEl?.classList.remove('hidden');
            return;
        }

        loadingEl?.classList.add('hidden');
        grid.replaceChildren();

        if (!Array.isArray(reviews) || reviews.length === 0) {
            emptyEl?.classList.remove('hidden');
            return;
        }

        const frag = document.createDocumentFragment();
        for (const review of reviews) frag.append(renderCard(tpl, review));
        grid.append(frag);
        renderSummary(sectionEl, reviews);
        setupSeeMore(sectionEl);
    }

    const SEE_MORE_LIMIT = 6;

    function setupSeeMore(sectionEl) {
        const grid = sectionEl.querySelector('[data-reviews-container]');
        const wrap = sectionEl.querySelector('[data-reviews-see-more-wrap]');
        const btn = sectionEl.querySelector('[data-reviews-see-more]');
        if (!grid || !wrap || !btn) return;

        let collapsed = true;

        function refresh() {
            const total = grid.children.length;
            if (total <= SEE_MORE_LIMIT) {
                for (const c of grid.children) c.classList.remove('is-hidden');
                wrap.classList.add('hidden');
                return;
            }
            Array.from(grid.children).forEach((c, i) => {
                c.classList.toggle('is-hidden', collapsed && i >= SEE_MORE_LIMIT);
            });
            wrap.classList.remove('hidden');
        }

        if (btn.dataset.bound !== '1') {
            btn.addEventListener('click', () => {
                collapsed = !collapsed;
                btn.textContent = collapsed ? 'Mehr anzeigen' : 'Weniger anzeigen';
                btn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
                refresh();
            });
            btn.dataset.bound = '1';
        }

        refresh();
    }

    function bindForm(sectionEl) {
        const form = sectionEl.querySelector('[data-reviews-form]');
        if (!form) return;

        const toggleBtn = sectionEl.querySelector('[data-reviews-form-toggle]');
        toggleBtn?.addEventListener('click', () => {
            form.classList.remove('hidden');
            toggleBtn.classList.add('hidden');
            toggleBtn.setAttribute('aria-expanded', 'true');
            statusEl?.classList.add('hidden');
            requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
            form.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        });

        const statusEl = sectionEl.querySelector('[data-reviews-form-status]');
        const submitBtn = form.querySelector('.reviews-form__submit');

        function setStatus(kind, message) {
            statusEl.textContent = message;
            statusEl.className = `reviews-form__status reviews-form__status--${kind}`;
            statusEl.classList.remove('hidden');
        }

        form.addEventListener('submit', async (e) => {
            e.preventDefault();
            if (!form.reportValidity()) return;

            const groupSlug = sectionEl.dataset.productGroup;
            const productHandle = sectionEl.dataset.productHandle;
            const productName = sectionEl.dataset.productName;

            if (!API_BASE) {
                setStatus('error', 'API_BASE ist nicht gesetzt (reviews.js).');
                return;
            }
            if (!groupSlug) {
                setStatus('error', 'Diesem Produkt fehlt das Metafeld custom.product_group.');
                return;
            }
            if (!productHandle) {
                setStatus('error', 'Produkt-Handle fehlt.');
                return;
            }

            submitBtn.disabled = true;
            statusEl.classList.add('hidden');

            const data = new FormData(form);

            const payload = {
                group: { slug: groupSlug },
                product: { handle: productHandle, name: productName },
                authorName: data.get('authorName'),
                reviewerEmail: data.get('reviewerEmail'),
                rating: Number(data.get('rating')),
                body: data.get('body'),
            };
            const title = (data.get('title') || '').trim();
            if (title) payload.title = title;

            try {
                const createRes = await fetch(`${API_BASE}/reviews`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                    body: JSON.stringify(payload),
                });
                if (!createRes.ok) throw new Error(`Create failed: ${createRes.status}`);
                const review = await createRes.json();

                const files = data.getAll('files').filter(f => f instanceof File && f.size > 0).slice(0, 10);
                if (files.length) {
                    const fd = new FormData();
                    for (const f of files) fd.append('files', f);
                    const uploadRes = await fetch(`${API_BASE}/reviews/${encodeURIComponent(review.id)}/attachments`, {
                        method: 'POST',
                        body: fd,
                    });
                    if (!uploadRes.ok) console.warn('reviews: attachment upload failed', uploadRes.status);
                }

                form.reset();
                form.classList.add('hidden');
                toggleBtn?.classList.remove('hidden');
                toggleBtn?.setAttribute('aria-expanded', 'false');
                requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
                setStatus('ok', 'Danke! Deine Bewertung wird nach Prüfung veröffentlicht.');
            } catch (err) {
                console.error('reviews: submit failed', err);
                setStatus('error', 'Etwas ist schiefgelaufen. Bitte versuche es später erneut.');
            } finally {
                submitBtn.disabled = false;
            }
        });
    }

    const MAX_FILES = 10;

    function setupFileUpload(sectionEl) {
        const input = sectionEl.querySelector('[data-reviews-file-input]');
        const dropzone = sectionEl.querySelector('[data-reviews-upload]');
        const list = sectionEl.querySelector('[data-reviews-file-list]');
        if (!input || !list) return;

        // Accumulated selection is the source of truth. The native file input
        // replaces its FileList on every pick, so each new batch would
        // otherwise overwrite the previous one.
        let selected = [];

        function sync() {
            const dt = new DataTransfer();
            selected.forEach((f) => dt.items.add(f));
            input.files = dt.files;
            render();
        }

        function setFiles(files) {
            selected = files.slice(0, MAX_FILES);
            sync();
        }

        function addFiles(files) {
            const key = (f) => `${f.name}:${f.size}:${f.lastModified}`;
            const have = new Set(selected.map(key));
            const merged = selected.concat(files.filter((f) => !have.has(key(f))));
            setFiles(merged);
        }

        function render() {
            list.replaceChildren();
            const files = selected;
            files.forEach((f, i) => {
                const li = document.createElement('li');
                li.className = 'reviews-form__upload-item';

                const img = document.createElement('img');
                img.className = 'reviews-form__upload-thumb';
                img.alt = '';
                img.src = URL.createObjectURL(f);
                img.addEventListener('load', () => URL.revokeObjectURL(img.src), { once: true });

                const name = document.createElement('span');
                name.className = 'reviews-form__upload-name';
                name.textContent = f.name;

                const remove = document.createElement('button');
                remove.type = 'button';
                remove.className = 'reviews-form__upload-remove';
                remove.setAttribute('aria-label', `${f.name} entfernen`);
                remove.textContent = '×';
                remove.addEventListener('click', () => {
                    setFiles(selected.filter((_, idx) => idx !== i));
                });

                li.append(img, name, remove);
                list.append(li);
            });
            list.classList.toggle('hidden', files.length === 0);
        }

        input.addEventListener('change', () => addFiles(Array.from(input.files || [])));

        ['dragenter', 'dragover'].forEach((ev) =>
            dropzone.addEventListener(ev, (e) => {
                e.preventDefault();
                dropzone.classList.add('is-dragover');
            })
        );
        ['dragleave', 'dragend', 'drop'].forEach((ev) =>
            dropzone.addEventListener(ev, () => dropzone.classList.remove('is-dragover'))
        );
        dropzone.addEventListener('drop', (e) => {
            e.preventDefault();
            const dropped = Array.from(e.dataTransfer?.files || []).filter((f) => f.type.startsWith('image/'));
            if (dropped.length) addFiles(dropped);
        });

        const form = sectionEl.querySelector('[data-reviews-form]');
        form?.addEventListener('reset', () => requestAnimationFrame(() => setFiles([])));
    }

    function init() {
        document.querySelectorAll('.reviews-section[data-product-group]').forEach((el) => {
            loadSection(el);
            bindForm(el);
            setupFileUpload(el);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
